import React, { useEffect, useState } from 'react';
import axiosInstance from '../config/axiosConfig';

const InstructionComponent = () => {
  const [instruction, setInstruction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(true); // state to control visibility

  useEffect(() => {
    const fetchInstruction = async () => {
      try {
        const response = await axiosInstance.get('/instructions/');
        if (response.status === 200) {
          setInstruction(response.data);
        } else {
          setError('No instruction found');
        }
      } catch (error) {
        setError('Error fetching instruction');
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchInstruction();
  }, []);

  const handleCloseInstruction = () => {
    setVisible(false); // hides the instruction by changing visibility
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>


      {instruction ? (
        <div
          className="instruction"
          style={{ display: visible ? 'flex' : 'none' }} // Hide the instruction if visible is false
        >
          <div className="d-block text-center">
      <div className="d-flex justify-content-between px-30">
            <h1 className="text-center text-white px-5">{instruction.name}</h1>
             <button className="btn btn-outline-light text-white close-instruction" onClick={handleCloseInstruction}>
              Zamknij
            </button>
      </div>
            <div dangerouslySetInnerHTML={{ __html: instruction.content }}
            className="mb-5 text-white"></div>
            {instruction.img && (
              <img
                src={`${process.env.REACT_APP_MEDIA_URL}${instruction.img}`}
                alt={instruction.name}
                style={{ maxWidth: '100%' }}
              />
            )}

          </div>
        </div>
      ) : (
        <div>No instruction found</div>
      )}
    </>
  );
};

export default InstructionComponent;
